// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__dJmQH","resendInfoText":"OnGoingPaymentBox_resendInfoText__2kOz9"};